import { Box, Button } from '@usap/uicomponents'
import styled from 'styled-components'

const border2Color = props => props.theme.global.colors['border-2'];
const whiteColor = props => props.theme.global.colors['white'];

export const OrderDetailsButtonContainer = styled(Box)`
  width: 100%;
`

export const OrderDetailsGrayButton = styled(Button)`
  width: 300px;
  height: 40px;
  border: 2px solid #acacac;
  background-color: #acacac;
  border-radius: 32px;

  :hover {
    background-color: #6d6d6d;
    border: 2px solid #6d6d6d;
  }

  :disabled {
    opacity: 1;
    cursor: not-allowed;
    border: 2px solid #acacac;
    background-color: #acacac;
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`

export const OrderDetailsBlueButton = styled(Button)`
  width: 300px;
  height: 40px;
  background-color: #2e4787;
  border: 2px solid #2e4787;
  border-radius: 32px;
  cursor: pointer;

  :hover {
    background-color: #3557b1;
    border: 2px solid #3557b1;
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`
export const OrderDetailsCtaWmo = styled(Button)`
  width: 100%;
  min-height: 40px;
  height: auto;
  background-color: ${whiteColor};
  border: 1px solid ${border2Color};
  border-radius: 4px;
  cursor: pointer;
  padding: 4px;
  :hover {
    background-color: ${whiteColor};
    border: 1px solid ${border2Color};
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`
